module.exports = __webpack_public_path__ + "img/17-02.c4c5f6b5.png";